import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WINDOW_PROVIDERS } from './window.service';

@NgModule({
  imports: [CommonModule],
  providers: [WINDOW_PROVIDERS],
})
export class ServiceModule {}
